<template>
  <div>
    <TitleLine class="text-capitalize mb-2" :title="title" />

    <v-row align="center" no-gutters>
      <v-col
        v-for="opt in composition.options"
        :key="opt"
        class="mr-2"
        cols="auto"
      >
        <div
          :class="[
            $style.bulletColor,
            'mb-2 p-1',
            { [$style.bulletColorActive]: optSelected === opt },
          ]"
          @click="onSelect(opt)"
        >
          <div
            :class="$style.bulletColorInner"
            :style="{ backgroundColor: opt }"
          ></div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'

import CompositionOrder from '@/models/compositionOrder.model'

@Component
export default class CompositeProductCompositionColor extends Vue {
  @Prop({
    type: Object,
    required: true,
  })
  composition

  optSelected = null

  titles = {
    color_decoracion: 'Color decoración',
  }

  optLabel = {
    '#ff0000': 'Rojo',
    '#ffa5c6': 'Rosado',
    '#b436ae': 'Violeta',
    '#f7fb00': 'Amarillo',
    '#78b575': 'Verde',
    '#4063a6': 'Azul',
    '#000002': 'Negro',
    '#c5c3c6': 'Plateado',
    '#caab5e': 'Dorado',
  }

  onSelect(opt) {
    if (opt) {
      this.optSelected = opt

      CompositionOrder.insert({
        data: {
          id: this.composition.name,
          name: this.optLabel[opt],
          data: opt,
          quantity: 1,
          price: 0,
          isAdition: false,
        },
      })

      this.$emit('updateOrder')
    }
  }

  get title() {
    return this.titles[this.composition.id]
  }
}
</script>

<style lang="scss" module>
.bulletColor {
  border: 1px solid $gray-300;
  border-radius: 50%;
  cursor: pointer;

  &.bulletColorActive {
    border: 2px solid $color-content;
  }

  .bulletColorInner {
    border-radius: 50%;
    height: 32px;
    width: 32px;
  }
}
</style>
